<template>
<div class="chapter">
<div class="inner_page">
<div style="margin-top:2em;">
<h2 class="h2v"><a id="page_xvii"></a>LIST OF TEXTUAL ABBREVIATIONS</h2>
<p class="noindent">The following is a list of the abbreviations used within the present work when referring to Plato's texts. Note that if a Stephanus number is cited <em>without</em> being preceded by one of the following abbreviations, the citation is from the <em>Cratylus.</em></p>
<table class="abb" width="100%">
<colgroup><col width="20%"/>
<col width="80%"/>
</colgroup><tbody><tr>
<td>Ap.</td>
<td>(Apology)</td>
</tr>
<tr>
<td>Epist.</td>
<td>(Letters)</td>
</tr>
<tr>
<td>Euthd.</td>
<td>(Euthydemus)</td>
</tr>
<tr>
<td>Euthr.</td>
<td>(Euthyphro)</td>
</tr>
<tr>
<td>Hipp.</td>
<td>(Hipparchus)</td>
</tr>
<tr>
<td>Lg.</td>
<td>(Laws)</td>
</tr>
<tr>
<td>Phd.</td>
<td>(Phaedo)</td>
</tr>
<tr>
<td>Phdr.</td>
<td>(Phaedrus)</td>
</tr>
<tr>
<td>Phil.</td>
<td>(Philebus)</td>
</tr>
<tr>
<td>Prot.</td>
<td>(Protagoras)</td>
</tr>
<tr>
<td>Rep.</td>
<td>(Republic)</td>
</tr>
<tr>
<td>Stat.</td>
<td>(Statesman)</td>
</tr>
<tr>
<td>Symp.</td>
<td>(Symposium)</td>
</tr>
<tr>
<td>Tht.</td>
<td>(Theaetetus)<a id="page_xviii"></a></td>
</tr>
</tbody></table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Abbrivations.vue?94bb8528